// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file analytics/v2/analytics.proto (package analytics.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { Timestamp } from '@bufbuild/protobuf/wkt'
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file analytics/v2/analytics.proto.
 */
export const file_analytics_v2_analytics: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_google_protobuf_timestamp]
  )

/**
 * Coordinates
 *
 * @generated from message analytics.v2.Coordinate
 */
export type Coordinate = Message<'analytics.v2.Coordinate'> & {
  /**
   * @generated from field: float longitude = 1;
   */
  longitude: number

  /**
   * @generated from field: float latitude = 2;
   */
  latitude: number
}

/**
 * Describes the message analytics.v2.Coordinate.
 * Use `create(CoordinateSchema)` to create a new message.
 */
export const CoordinateSchema: GenMessage<Coordinate> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 0)

/**
 * @generated from message analytics.v2.ScatterPlotCoordinate
 */
export type ScatterPlotCoordinate = Message<'analytics.v2.ScatterPlotCoordinate'> & {
  /**
   * @generated from field: bool is_interstitial = 1;
   */
  isInterstitial: boolean

  /**
   * @generated from field: repeated float coordinates = 2;
   */
  coordinates: number[]
}

/**
 * Describes the message analytics.v2.ScatterPlotCoordinate.
 * Use `create(ScatterPlotCoordinateSchema)` to create a new message.
 */
export const ScatterPlotCoordinateSchema: GenMessage<ScatterPlotCoordinate> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 1)

/**
 * GeoJson
 *
 * @generated from message analytics.v2.GeoJson
 */
export type GeoJson = Message<'analytics.v2.GeoJson'> & {
  /**
   * @generated from field: string data_type = 1;
   */
  dataType: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: repeated analytics.v2.GeoDataFeature features = 3;
   */
  features: GeoDataFeature[]
}

/**
 * Describes the message analytics.v2.GeoJson.
 * Use `create(GeoJsonSchema)` to create a new message.
 */
export const GeoJsonSchema: GenMessage<GeoJson> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 2)

/**
 * @generated from message analytics.v2.GeoDataFeature
 */
export type GeoDataFeature = Message<'analytics.v2.GeoDataFeature'> & {
  /**
   * @generated from field: string feature_type = 1;
   */
  featureType: string

  /**
   * @generated from field: bytes properties = 2;
   */
  properties: Uint8Array

  /**
   * @generated from field: analytics.v2.GeoGeometry geometry = 3;
   */
  geometry?: GeoGeometry
}

/**
 * Describes the message analytics.v2.GeoDataFeature.
 * Use `create(GeoDataFeatureSchema)` to create a new message.
 */
export const GeoDataFeatureSchema: GenMessage<GeoDataFeature> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 3)

/**
 * @generated from message analytics.v2.GeoGeometry
 */
export type GeoGeometry = Message<'analytics.v2.GeoGeometry'> & {
  /**
   * @generated from field: string geometry_type = 1;
   */
  geometryType: string

  /**
   * @generated from field: bytes coordinates = 2;
   */
  coordinates: Uint8Array
}

/**
 * Describes the message analytics.v2.GeoGeometry.
 * Use `create(GeoGeometrySchema)` to create a new message.
 */
export const GeoGeometrySchema: GenMessage<GeoGeometry> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 4)

/**
 * Pagination info
 *
 * @generated from message analytics.v2.Pagination
 */
export type Pagination = Message<'analytics.v2.Pagination'> & {
  /**
   * @generated from field: int64 total_pages = 1;
   */
  totalPages: bigint

  /**
   * @generated from field: int64 page_num = 2;
   */
  pageNum: bigint
}

/**
 * Describes the message analytics.v2.Pagination.
 * Use `create(PaginationSchema)` to create a new message.
 */
export const PaginationSchema: GenMessage<Pagination> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 5)

/**
 * Audience Insights
 *
 * @generated from message analytics.v2.CompetitiveBenchmarkingData
 */
export type CompetitiveBenchmarkingData = Message<'analytics.v2.CompetitiveBenchmarkingData'> & {
  /**
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp

  /**
   * @generated from field: int32 user_scans = 3;
   */
  userScans: number

  /**
   * @generated from field: int32 user_link_clicks = 4;
   */
  userLinkClicks: number

  /**
   * @generated from field: int32 user_crm_collected = 5;
   */
  userCrmCollected: number

  /**
   * @generated from field: int32 benchmark_scans = 6;
   */
  benchmarkScans: number

  /**
   * @generated from field: int32 benchmark_link_clicks = 7;
   */
  benchmarkLinkClicks: number

  /**
   * @generated from field: int32 benchmark_crm_collected = 8;
   */
  benchmarkCrmCollected: number
}

/**
 * Describes the message analytics.v2.CompetitiveBenchmarkingData.
 * Use `create(CompetitiveBenchmarkingDataSchema)` to create a new message.
 */
export const CompetitiveBenchmarkingDataSchema: GenMessage<CompetitiveBenchmarkingData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 6)

/**
 * Range summary
 *
 * @generated from message analytics.v2.RangeSummaryData
 */
export type RangeSummaryData = Message<'analytics.v2.RangeSummaryData'> & {
  /**
   * @generated from field: int32 active_codes = 1;
   */
  activeCodes: number

  /**
   * @generated from field: int32 active_pages = 2;
   */
  activePages: number

  /**
   * @generated from field: int32 scans = 3;
   */
  scans: number

  /**
   * @generated from field: int32 short_url_clicks = 4;
   */
  shortUrlClicks: number

  /**
   * @generated from field: int32 taps = 5;
   */
  taps: number

  /**
   * @generated from field: int32 page_views = 6;
   */
  pageViews: number

  /**
   * @generated from field: int32 link_clicks = 7;
   */
  linkClicks: number

  /**
   * @generated from field: int32 contacts = 8;
   */
  contacts: number
}

/**
 * Describes the message analytics.v2.RangeSummaryData.
 * Use `create(RangeSummaryDataSchema)` to create a new message.
 */
export const RangeSummaryDataSchema: GenMessage<RangeSummaryData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 7)

/**
 * Summary
 *
 * @generated from message analytics.v2.InnerSummary
 */
export type InnerSummary = Message<'analytics.v2.InnerSummary'> & {
  /**
   * @generated from field: int32 current = 1;
   */
  current: number

  /**
   * @generated from field: int32 previous = 2;
   */
  previous: number

  /**
   * @generated from field: int32 current_unique = 3;
   */
  currentUnique: number

  /**
   * @generated from field: int32 previous_unique = 4;
   */
  previousUnique: number
}

/**
 * Describes the message analytics.v2.InnerSummary.
 * Use `create(InnerSummarySchema)` to create a new message.
 */
export const InnerSummarySchema: GenMessage<InnerSummary> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 8)

/**
 * @generated from message analytics.v2.SummaryData
 */
export type SummaryData = Message<'analytics.v2.SummaryData'> & {
  /**
   * @generated from field: analytics.v2.InnerSummary today = 1;
   */
  today?: InnerSummary

  /**
   * @generated from field: analytics.v2.InnerSummary last_7_days = 2;
   */
  last7Days?: InnerSummary

  /**
   * @generated from field: analytics.v2.InnerSummary last_30_days = 3;
   */
  last30Days?: InnerSummary

  /**
   * @generated from field: analytics.v2.InnerSummary last_90_days = 4;
   */
  last90Days?: InnerSummary

  /**
   * @generated from field: analytics.v2.InnerSummary all_time = 5;
   */
  allTime?: InnerSummary
}

/**
 * Describes the message analytics.v2.SummaryData.
 * Use `create(SummaryDataSchema)` to create a new message.
 */
export const SummaryDataSchema: GenMessage<SummaryData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 9)

/**
 * @generated from message analytics.v2.SummaryPixelsData
 */
export type SummaryPixelsData = Message<'analytics.v2.SummaryPixelsData'> & {
  /**
   * @generated from field: int32 count = 1;
   */
  count: number

  /**
   * @generated from field: int32 unique_count = 2;
   */
  uniqueCount: number

  /**
   * @generated from field: int32 pixel_page_views = 3;
   */
  pixelPageViews: number

  /**
   * @generated from field: int32 pixel_conversions = 4;
   */
  pixelConversions: number

  /**
   * @generated from field: int32 pixel_unique_conversions = 5;
   */
  pixelUniqueConversions: number
}

/**
 * Describes the message analytics.v2.SummaryPixelsData.
 * Use `create(SummaryPixelsDataSchema)` to create a new message.
 */
export const SummaryPixelsDataSchema: GenMessage<SummaryPixelsData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 10)

/**
 * Count
 *
 * @generated from message analytics.v2.FlowcodeCount
 */
export type FlowcodeCount = Message<'analytics.v2.FlowcodeCount'> & {
  /**
   * @generated from field: string asset_id = 1;
   */
  assetId: string

  /**
   * @generated from field: int64 count = 2;
   */
  count: bigint

  /**
   * @generated from field: int64 unique_users = 3;
   */
  uniqueUsers: bigint
}

/**
 * Describes the message analytics.v2.FlowcodeCount.
 * Use `create(FlowcodeCountSchema)` to create a new message.
 */
export const FlowcodeCountSchema: GenMessage<FlowcodeCount> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 11)

/**
 * @generated from message analytics.v2.FlowpageCount
 */
export type FlowpageCount = Message<'analytics.v2.FlowpageCount'> & {
  /**
   * @generated from field: string page_id = 1;
   */
  pageId: string

  /**
   * @generated from field: int64 count = 2;
   */
  count: bigint

  /**
   * @generated from field: float clickthrough_rate = 3;
   */
  clickthroughRate: number
}

/**
 * Describes the message analytics.v2.FlowpageCount.
 * Use `create(FlowpageCountSchema)` to create a new message.
 */
export const FlowpageCountSchema: GenMessage<FlowpageCount> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 12)

/**
 * @generated from message analytics.v2.CountData
 */
export type CountData = Message<'analytics.v2.CountData'> & {
  /**
   * @generated from field: map<string, analytics.v2.FlowcodeCount> flowcode_counts = 1;
   */
  flowcodeCounts: { [key: string]: FlowcodeCount }

  /**
   * @generated from field: map<string, analytics.v2.FlowpageCount> flowpage_counts = 2;
   */
  flowpageCounts: { [key: string]: FlowpageCount }
}

/**
 * Describes the message analytics.v2.CountData.
 * Use `create(CountDataSchema)` to create a new message.
 */
export const CountDataSchema: GenMessage<CountData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 13)

/**
 * Raw events
 *
 * @generated from message analytics.v2.RawEventsData
 */
export type RawEventsData = Message<'analytics.v2.RawEventsData'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: google.protobuf.Timestamp event_time = 2;
   */
  eventTime?: Timestamp

  /**
   * @generated from field: string asset_id = 3;
   */
  assetId: string

  /**
   * @generated from field: string asset_name = 4;
   */
  assetName: string

  /**
   * @generated from field: string directory_name = 5;
   */
  directoryName: string

  /**
   * @generated from field: analytics.v2.OperatingSystem operating_system = 6;
   */
  operatingSystem: OperatingSystem

  /**
   * @generated from field: analytics.v2.Device device = 7;
   */
  device: Device

  /**
   * @generated from field: analytics.v2.EventType event_type = 8;
   */
  eventType: EventType

  /**
   * @generated from field: string destination = 9;
   */
  destination: string

  /**
   * @generated from field: string link_name = 10;
   */
  linkName: string

  /**
   * @generated from field: string country = 11;
   */
  country: string

  /**
   * @generated from field: string state = 12;
   */
  state: string

  /**
   * @generated from field: string city = 13;
   */
  city: string

  /**
   * @generated from field: string zip = 14;
   */
  zip: string

  /**
   * @generated from field: float latitude = 15;
   */
  latitude: number

  /**
   * @generated from field: float longitude = 16;
   */
  longitude: number

  /**
   * @generated from field: string geo_type = 17;
   */
  geoType: string

  /**
   * @generated from field: string app_id = 18;
   */
  appId: string
}

/**
 * Describes the message analytics.v2.RawEventsData.
 * Use `create(RawEventsDataSchema)` to create a new message.
 */
export const RawEventsDataSchema: GenMessage<RawEventsData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 14)

/**
 * Top Codes
 *
 * @generated from message analytics.v2.TopCodesData
 */
export type TopCodesData = Message<'analytics.v2.TopCodesData'> & {
  /**
   * @generated from field: int32 count = 1;
   */
  count: number

  /**
   * @generated from field: string asset_id = 2;
   */
  assetId: string

  /**
   * @generated from field: string nickname = 3;
   */
  nickname: string

  /**
   * @generated from field: int32 all_time_count = 4;
   */
  allTimeCount: number

  /**
   * @generated from field: int32 previous_count = 5;
   */
  previousCount: number
}

/**
 * Describes the message analytics.v2.TopCodesData.
 * Use `create(TopCodesDataSchema)` to create a new message.
 */
export const TopCodesDataSchema: GenMessage<TopCodesData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 15)

/**
 * Top Codes Pixels
 *
 * @generated from message analytics.v2.TopCodesPixelsData
 */
export type TopCodesPixelsData = Message<'analytics.v2.TopCodesPixelsData'> & {
  /**
   * @generated from field: string asset_id = 1;
   */
  assetId: string

  /**
   * @generated from field: string nickname = 2;
   */
  nickname: string

  /**
   * @generated from field: int32 count = 3;
   */
  count: number

  /**
   * @generated from field: int32 unique_count = 4;
   */
  uniqueCount: number

  /**
   * @generated from field: int32 pixel_page_views = 5;
   */
  pixelPageViews: number

  /**
   * @generated from field: int32 pixel_conversions = 6;
   */
  pixelConversions: number

  /**
   * @generated from field: int32 pixel_unique_conversions = 7;
   */
  pixelUniqueConversions: number
}

/**
 * Describes the message analytics.v2.TopCodesPixelsData.
 * Use `create(TopCodesPixelsDataSchema)` to create a new message.
 */
export const TopCodesPixelsDataSchema: GenMessage<TopCodesPixelsData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 16)

/**
 * Top Paths Pixels
 *
 * @generated from message analytics.v2.TopPathsPixelsData
 */
export type TopPathsPixelsData = Message<'analytics.v2.TopPathsPixelsData'> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string

  /**
   * @generated from field: int32 pixel_page_views = 2;
   */
  pixelPageViews: number

  /**
   * @generated from field: int32 pixel_conversions = 3;
   */
  pixelConversions: number

  /**
   * @generated from field: int32 pixel_unique_conversions = 4;
   */
  pixelUniqueConversions: number
}

/**
 * Describes the message analytics.v2.TopPathsPixelsData.
 * Use `create(TopPathsPixelsDataSchema)` to create a new message.
 */
export const TopPathsPixelsDataSchema: GenMessage<TopPathsPixelsData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 17)

/**
 * Top Destinations
 *
 * @generated from message analytics.v2.TopDestinationsData
 */
export type TopDestinationsData = Message<'analytics.v2.TopDestinationsData'> & {
  /**
   * @generated from field: int32 count = 1;
   */
  count: number

  /**
   * @generated from field: string destination = 2;
   */
  destination: string

  /**
   * @generated from field: int32 all_time_count = 3;
   */
  allTimeCount: number

  /**
   * @generated from field: int32 previous_count = 4;
   */
  previousCount: number
}

/**
 * Describes the message analytics.v2.TopDestinationsData.
 * Use `create(TopDestinationsDataSchema)` to create a new message.
 */

export const TopDestinationsDataSchema: GenMessage<TopDestinationsData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 18)

/**
 * Top Pages
 *
 * @generated from message analytics.v2.TopPagesData
 */
export type TopPagesData = Message<'analytics.v2.TopPagesData'> & {
  /**
   * @generated from field: string page_id = 1;
   */
  pageId: string

  /**
   * @generated from field: string page_title = 2;
   */
  pageTitle: string

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 3;
   */
  deletedAt?: Timestamp

  /**
   * @generated from field: int32 page_views_count = 4;
   */
  pageViewsCount: number

  /**
   * @generated from field: int32 link_clicks_count = 5;
   */
  linkClicksCount: number

  /**
   * @generated from field: int32 contacts_collected_count = 6;
   */
  contactsCollectedCount: number

  /**
   * @generated from field: int32 all_time_views_count = 7;
   */
  allTimeViewsCount: number

  /**
   * @generated from field: int32 previous_page_views_count = 8;
   */
  previousPageViewsCount: number

  /**
   * @generated from field: int32 all_time_clicks_count = 9;
   */
  allTimeClicksCount: number

  /**
   * @generated from field: int32 previous_link_clicks_count = 10;
   */
  previousLinkClicksCount: number

  /**
   * @generated from field: float clickthrough_rate = 11;
   */
  clickthroughRate: number

  /**
   * @generated from field: string page_slug = 12;
   */
  pageSlug: string
}

/**
 * Describes the message analytics.v2.TopPagesData.
 * Use `create(TopPagesDataSchema)` to create a new message.
 */
export const TopPagesDataSchema: GenMessage<TopPagesData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 19)

/**
 * Top Links
 *
 * @generated from message analytics.v2.TopLinksData
 */
export type TopLinksData = Message<'analytics.v2.TopLinksData'> & {
  /**
   * @generated from field: int32 link_clicks_count = 1;
   */
  linkClicksCount: number

  /**
   * @generated from field: string link_id = 2;
   */
  linkId: string

  /**
   * @generated from field: string link_title = 3;
   */
  linkTitle: string

  /**
   * @generated from field: string link_type = 4;
   */
  linkType: string

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 5;
   */
  deletedAt?: Timestamp

  /**
   * @generated from field: string page_id = 6;
   */
  pageId: string

  /**
   * @generated from field: string page_title = 7;
   */
  pageTitle: string

  /**
   * @generated from field: google.protobuf.Timestamp page_deleted_at = 8;
   */
  pageDeletedAt?: Timestamp

  /**
   * @generated from field: int32 all_time_clicks_count = 9;
   */
  allTimeClicksCount: number

  /**
   * @generated from field: int32 previous_link_clicks_count = 10;
   */
  previousLinkClicksCount: number
}

/**
 * Describes the message analytics.v2.TopLinksData.
 * Use `create(TopLinksDataSchema)` to create a new message.
 */
export const TopLinksDataSchema: GenMessage<TopLinksData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 20)

/**
 * Top UTM Campaigns
 *
 * @generated from message analytics.v2.TopUTMCampaignsData
 */
export type TopUTMCampaignsData = Message<'analytics.v2.TopUTMCampaignsData'> & {
  /**
   * @generated from field: string utm_campaign = 1;
   */
  utmCampaign: string

  /**
   * @generated from field: string utm_term = 2;
   */
  utmTerm: string

  /**
   * @generated from field: string utm_source = 3;
   */
  utmSource: string

  /**
   * @generated from field: int32 page_views_count = 4;
   */
  pageViewsCount: number

  /**
   * @generated from field: int32 link_clicks_count = 5;
   */
  linkClicksCount: number

  /**
   * @generated from field: int32 contacts_collected_count = 6;
   */
  contactsCollectedCount: number

  /**
   * @generated from field: float clickthrough_rate = 7;
   */
  clickthroughRate: number
}

/**
 * Describes the message analytics.v2.TopUTMCampaignsData.
 * Use `create(TopUTMCampaignsDataSchema)` to create a new message.
 */
export const TopUTMCampaignsDataSchema: GenMessage<TopUTMCampaignsData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 21)

/**
 * Top UTM Terms
 *
 * @generated from message analytics.v2.TopUTMTermsData
 */
export type TopUTMTermsData = Message<'analytics.v2.TopUTMTermsData'> & {
  /**
   * @generated from field: string utm_campaign = 1;
   */
  utmCampaign: string

  /**
   * @generated from field: string utm_term = 2;
   */
  utmTerm: string

  /**
   * @generated from field: string utm_source = 3;
   */
  utmSource: string

  /**
   * @generated from field: int32 page_views_count = 4;
   */
  pageViewsCount: number

  /**
   * @generated from field: int32 link_clicks_count = 5;
   */
  linkClicksCount: number

  /**
   * @generated from field: int32 contacts_collected_count = 6;
   */
  contactsCollectedCount: number

  /**
   * @generated from field: float clickthrough_rate = 7;
   */
  clickthroughRate: number
}

/**
 * Describes the message analytics.v2.TopUTMTermsData.
 * Use `create(TopUTMTermsDataSchema)` to create a new message.
 */
export const TopUTMTermsDataSchema: GenMessage<TopUTMTermsData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 22)

/**
 * Top UTM Referrers
 *
 * @generated from message analytics.v2.TopUTMReferrersData
 */
export type TopUTMReferrersData = Message<'analytics.v2.TopUTMReferrersData'> & {
  /**
   * @generated from field: string utm_campaign = 1;
   */
  utmCampaign: string

  /**
   * @generated from field: string utm_term = 2;
   */
  utmTerm: string

  /**
   * @generated from field: string utm_source = 3;
   */
  utmSource: string

  /**
   * @generated from field: int32 page_views_count = 4;
   */
  pageViewsCount: number

  /**
   * @generated from field: int32 link_clicks_count = 5;
   */
  linkClicksCount: number

  /**
   * @generated from field: int32 contacts_collected_count = 6;
   */
  contactsCollectedCount: number

  /**
   * @generated from field: float clickthrough_rate = 7;
   */
  clickthroughRate: number
}

/**
 * Describes the message analytics.v2.TopUTMReferrersData.
 * Use `create(TopUTMReferrersDataSchema)` to create a new message.
 */
export const TopUTMReferrersDataSchema: GenMessage<TopUTMReferrersData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 23)

/**
 * Top Cities
 *
 * @generated from message analytics.v2.TopCitiesData
 */
export type TopCitiesData = Message<'analytics.v2.TopCitiesData'> & {
  /**
   * @generated from field: string postal_code = 1;
   */
  postalCode: string

  /**
   * @generated from field: string city = 2;
   */
  city: string

  /**
   * @generated from field: string state = 3;
   */
  state: string

  /**
   * @generated from field: string country = 4;
   */
  country: string

  /**
   * @generated from field: int32 page_views_count = 5;
   */
  pageViewsCount: number

  /**
   * @generated from field: int32 link_clicks_count = 6;
   */
  linkClicksCount: number

  /**
   * @generated from field: int32 count = 7;
   */
  count: number
}

/**
 * Describes the message analytics.v2.TopCitiesData.
 * Use `create(TopCitiesDataSchema)` to create a new message.
 */
export const TopCitiesDataSchema: GenMessage<TopCitiesData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 24)

/**
 * Top States
 *
 * @generated from message analytics.v2.TopStatesData
 */
export type TopStatesData = Message<'analytics.v2.TopStatesData'> & {
  /**
   * @generated from field: string state = 1;
   */
  state: string

  /**
   * @generated from field: string country = 2;
   */
  country: string

  /**
   * @generated from field: int32 page_views_count = 3;
   */
  pageViewsCount: number

  /**
   * @generated from field: int32 link_clicks_count = 4;
   */
  linkClicksCount: number

  /**
   * @generated from field: int32 count = 5;
   */
  count: number
}

/**
 * Describes the message analytics.v2.TopStatesData.
 * Use `create(TopStatesDataSchema)` to create a new message.
 */
export const TopStatesDataSchema: GenMessage<TopStatesData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 25)

/**
 * Top Days
 *
 * @generated from message analytics.v2.TopDaysData
 */
export type TopDaysData = Message<'analytics.v2.TopDaysData'> & {
  /**
   * @generated from field: int32 day = 1;
   */
  day: number

  /**
   * @generated from field: int32 page_views_count = 2;
   */
  pageViewsCount: number

  /**
   * @generated from field: int32 link_clicks_count = 3;
   */
  linkClicksCount: number

  /**
   * @generated from field: int32 count = 4;
   */
  count: number
}

/**
 * Describes the message analytics.v2.TopDaysData.
 * Use `create(TopDaysDataSchema)` to create a new message.
 */
export const TopDaysDataSchema: GenMessage<TopDaysData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 26)

/**
 * Top Hours
 *
 * @generated from message analytics.v2.TopHoursData
 */
export type TopHoursData = Message<'analytics.v2.TopHoursData'> & {
  /**
   * @generated from field: int32 hour = 1;
   */
  hour: number

  /**
   * @generated from field: int32 page_views_count = 2;
   */
  pageViewsCount: number

  /**
   * @generated from field: int32 link_clicks_count = 3;
   */
  linkClicksCount: number

  /**
   * @generated from field: int32 count = 4;
   */
  count: number
}

/**
 * Describes the message analytics.v2.TopHoursData.
 * Use `create(TopHoursDataSchema)` to create a new message.
 */
export const TopHoursDataSchema: GenMessage<TopHoursData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 27)

/**
 * Top Devices
 *
 * @generated from message analytics.v2.TopDevicesData
 */
export type TopDevicesData = Message<'analytics.v2.TopDevicesData'> & {
  /**
   * @generated from field: analytics.v2.Device device = 1;
   */
  device: Device

  /**
   * @generated from field: int32 page_views_count = 2;
   */
  pageViewsCount: number

  /**
   * @generated from field: int32 link_clicks_count = 3;
   */
  linkClicksCount: number

  /**
   * @generated from field: int32 count = 4;
   */
  count: number
}

/**
 * Describes the message analytics.v2.TopDevicesData.
 * Use `create(TopDevicesDataSchema)` to create a new message.
 */
export const TopDevicesDataSchema: GenMessage<TopDevicesData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 28)

/**
 * Top Operating Systems
 *
 * @generated from message analytics.v2.TopOperatingSystemsData
 */
export type TopOperatingSystemsData = Message<'analytics.v2.TopOperatingSystemsData'> & {
  /**
   * @generated from field: analytics.v2.OperatingSystem operating_system = 1;
   */
  operatingSystem: OperatingSystem

  /**
   * @generated from field: int32 page_views_count = 2;
   */
  pageViewsCount: number

  /**
   * @generated from field: int32 link_clicks_count = 3;
   */
  linkClicksCount: number

  /**
   * @generated from field: int32 count = 4;
   */
  count: number
}

/**
 * Describes the message analytics.v2.TopOperatingSystemsData.
 * Use `create(TopOperatingSystemsDataSchema)` to create a new message.
 */
export const TopOperatingSystemsDataSchema: GenMessage<TopOperatingSystemsData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 29)

/**
 * Top Tags
 *
 * @generated from message analytics.v2.TopTagsData
 */
export type TopTagsData = Message<'analytics.v2.TopTagsData'> & {
  /**
   * @generated from field: string tag_name = 1;
   */
  tagName: string

  /**
   * @generated from field: int32 count = 2;
   */
  count: number

  /**
   * @generated from field: int32 page_views_count = 3;
   */
  pageViewsCount: number

  /**
   * @generated from field: int32 link_clicks_count = 4;
   */
  linkClicksCount: number

  /**
   * @generated from field: int32 contacts_collected_count = 5;
   */
  contactsCollectedCount: number

  /**
   * @generated from field: int32 all_time_count = 6;
   */
  allTimeCount: number

  /**
   * @generated from field: int32 previous_count = 7;
   */
  previousCount: number

  /**
   * @generated from field: float clickthrough_rate = 8;
   */
  clickthroughRate: number
}

/**
 * Describes the message analytics.v2.TopTagsData.
 * Use `create(TopTagsDataSchema)` to create a new message.
 */
export const TopTagsDataSchema: GenMessage<TopTagsData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 30)

/**
 * Date range
 *
 * @generated from message analytics.v2.DateRangeData
 */
export type DateRangeData = Message<'analytics.v2.DateRangeData'> & {
  /**
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp

  /**
   * @generated from field: int32 hits = 3;
   */
  hits: number

  /**
   * @generated from field: int32 unique_hits = 4;
   */
  uniqueHits: number

  /**
   * @generated from field: int32 page_views = 5;
   */
  pageViews: number

  /**
   * @generated from field: int32 link_clicks = 6;
   */
  linkClicks: number

  /**
   * @generated from field: int32 contacts = 7;
   */
  contacts: number
}

/**
 * Describes the message analytics.v2.DateRangeData.
 * Use `create(DateRangeDataSchema)` to create a new message.
 */
export const DateRangeDataSchema: GenMessage<DateRangeData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 31)

/**
 * @generated from message analytics.v2.DateRangeTotals
 */
export type DateRangeTotals = Message<'analytics.v2.DateRangeTotals'> & {
  /**
   * @generated from field: int32 hits = 1;
   */
  hits: number

  /**
   * @generated from field: int32 unique_hits = 2;
   */
  uniqueHits: number

  /**
   * @generated from field: int32 page_views = 3;
   */
  pageViews: number

  /**
   * @generated from field: int32 link_clicks = 4;
   */
  linkClicks: number

  /**
   * @generated from field: int32 contacts = 5;
   */
  contacts: number

  /**
   * @generated from field: int32 previous_hits = 6;
   */
  previousHits: number

  /**
   * @generated from field: int32 previous_unique_hits = 7;
   */
  previousUniqueHits: number

  /**
   * @generated from field: int32 previous_page_views = 8;
   */
  previousPageViews: number

  /**
   * @generated from field: int32 previous_link_clicks = 9;
   */
  previousLinkClicks: number

  /**
   * @generated from field: int32 previous_contacts = 10;
   */
  previousContacts: number

  /**
   * @generated from field: google.protobuf.Timestamp cap_exceeded_date = 11;
   */
  capExceededDate?: Timestamp

  /**
   * @generated from field: float clickthrough_rate = 12;
   */
  clickthroughRate: number
}

/**
 * Describes the message analytics.v2.DateRangeTotals.
 * Use `create(DateRangeTotalsSchema)` to create a new message.
 */
export const DateRangeTotalsSchema: GenMessage<DateRangeTotals> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 32)

/**
 * Date Range Pixels
 *
 * @generated from message analytics.v2.DateRangePixelsData
 */
export type DateRangePixelsData = Message<'analytics.v2.DateRangePixelsData'> & {
  /**
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp

  /**
   * @generated from field: int32 hits = 3;
   */
  hits: number

  /**
   * @generated from field: int32 unique_hits = 4;
   */
  uniqueHits: number

  /**
   * @generated from field: int32 pixel_page_views = 5;
   */
  pixelPageViews: number

  /**
   * @generated from field: int32 pixel_conversions = 6;
   */
  pixelConversions: number

  /**
   * @generated from field: int32 pixel_unique_conversions = 7;
   */
  pixelUniqueConversions: number
}

/**
 * Describes the message analytics.v2.DateRangePixelsData.
 * Use `create(DateRangePixelsDataSchema)` to create a new message.
 */
export const DateRangePixelsDataSchema: GenMessage<DateRangePixelsData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 33)

/**
 * @generated from message analytics.v2.DateRangePixelsTotals
 */
export type DateRangePixelsTotals = Message<'analytics.v2.DateRangePixelsTotals'> & {
  /**
   * @generated from field: int32 hits = 1;
   */
  hits: number

  /**
   * @generated from field: int32 unique_hits = 2;
   */
  uniqueHits: number

  /**
   * @generated from field: int32 pixel_page_views = 3;
   */
  pixelPageViews: number

  /**
   * @generated from field: int32 pixel_conversions = 4;
   */
  pixelConversions: number

  /**
   * @generated from field: int32 pixel_unique_conversions = 5;
   */
  pixelUniqueConversions: number
}

/**
 * Describes the message analytics.v2.DateRangePixelsTotals.
 * Use `create(DateRangePixelsTotalsSchema)` to create a new message.
 */
export const DateRangePixelsTotalsSchema: GenMessage<DateRangePixelsTotals> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 34)

/**
 * @generated from message analytics.v2.OrgActivityData
 */
export type OrgActivityData = Message<'analytics.v2.OrgActivityData'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string

  /**
   * @generated from field: int32 activity_count = 2;
   */
  activityCount: number

  /**
   * @generated from field: int32 data_cap = 3;
   */
  dataCap: number

  /**
   * @generated from field: google.protobuf.Timestamp cap_exceeded_date = 4;
   */
  capExceededDate?: Timestamp
}

/**
 * Describes the message analytics.v2.OrgActivityData.
 * Use `create(OrgActivityDataSchema)` to create a new message.
 */
export const OrgActivityDataSchema: GenMessage<OrgActivityData> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_analytics, 35)

/**
 * Types
 *
 * @generated from enum analytics.v2.Product
 */
export enum Product {
  /**
   * @generated from enum value: PRODUCT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PRODUCT_FLOWPAGE = 1;
   */
  FLOWPAGE = 1,

  /**
   * @generated from enum value: PRODUCT_ALL = 2;
   */
  ALL = 2,

  /**
   * @generated from enum value: PRODUCT_FLOWCODE = 3;
   */
  FLOWCODE = 3,

  /**
   * @generated from enum value: PRODUCT_PIXEL = 4;
   */
  PIXEL = 4
}

/**
 * Describes the enum analytics.v2.Product.
 */
export const ProductSchema: GenEnum<Product> =
  /*@__PURE__*/
  enumDesc(file_analytics_v2_analytics, 0)

/**
 * @generated from enum analytics.v2.EventType
 */
export enum EventType {
  /**
   * @generated from enum value: EVENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EVENT_TYPE_SCAN = 1;
   */
  SCAN = 1,

  /**
   * @generated from enum value: EVENT_TYPE_SHORT_URL_CLICK = 2;
   */
  SHORT_URL_CLICK = 2,

  /**
   * @generated from enum value: EVENT_TYPE_TAP = 3;
   */
  TAP = 3,

  /**
   * @generated from enum value: EVENT_TYPE_PAGE_VIEW = 4;
   */
  PAGE_VIEW = 4,

  /**
   * @generated from enum value: EVENT_TYPE_LINK_CLICK = 5;
   */
  LINK_CLICK = 5,

  /**
   * @generated from enum value: EVENT_TYPE_CRM = 6;
   */
  CRM = 6,

  /**
   * @generated from enum value: EVENT_TYPE_PIXEL_PAGE_VIEW = 7;
   */
  PIXEL_PAGE_VIEW = 7,

  /**
   * @generated from enum value: EVENT_TYPE_PIXEL_CONVERSION = 8;
   */
  PIXEL_CONVERSION = 8,

  /**
   * @generated from enum value: EVENT_TYPE_PIXEL_BUTTON_CLICK = 9;
   */
  PIXEL_BUTTON_CLICK = 9,

  /**
   * @generated from enum value: EVENT_TYPE_PIXEL_LINK_CLICK = 10;
   */
  PIXEL_LINK_CLICK = 10
}

/**
 * Describes the enum analytics.v2.EventType.
 */
export const EventTypeSchema: GenEnum<EventType> =
  /*@__PURE__*/
  enumDesc(file_analytics_v2_analytics, 1)

/**
 * @generated from enum analytics.v2.Interval
 */
export enum Interval {
  /**
   * @generated from enum value: INTERVAL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INTERVAL_HOURLY = 1;
   */
  HOURLY = 1,

  /**
   * @generated from enum value: INTERVAL_DAILY = 2;
   */
  DAILY = 2,

  /**
   * @generated from enum value: INTERVAL_WEEKLY = 3;
   */
  WEEKLY = 3
}

/**
 * Describes the enum analytics.v2.Interval.
 */
export const IntervalSchema: GenEnum<Interval> =
  /*@__PURE__*/
  enumDesc(file_analytics_v2_analytics, 2)

/**
 * @generated from enum analytics.v2.Device
 */
export enum Device {
  /**
   * @generated from enum value: DEVICE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEVICE_MOBILE = 1;
   */
  MOBILE = 1,

  /**
   * @generated from enum value: DEVICE_TABLET = 2;
   */
  TABLET = 2,

  /**
   * @generated from enum value: DEVICE_DESKTOP = 3;
   */
  DESKTOP = 3,

  /**
   * @generated from enum value: DEVICE_UNKNOWN = 4;
   */
  UNKNOWN = 4
}

/**
 * Describes the enum analytics.v2.Device.
 */
export const DeviceSchema: GenEnum<Device> = /*@__PURE__*/ enumDesc(file_analytics_v2_analytics, 3)

/**
 * @generated from enum analytics.v2.OperatingSystem
 */
export enum OperatingSystem {
  /**
   * @generated from enum value: OPERATING_SYSTEM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: OPERATING_SYSTEM_ANDROID = 1;
   */
  ANDROID = 1,

  /**
   * @generated from enum value: OPERATING_SYSTEM_WINDOWS = 2;
   */
  WINDOWS = 2,

  /**
   * @generated from enum value: OPERATING_SYSTEM_IOS = 3;
   */
  IOS = 3,

  /**
   * @generated from enum value: OPERATING_SYSTEM_MACOS = 4;
   */
  MACOS = 4,

  /**
   * @generated from enum value: OPERATING_SYSTEM_LINUX = 5;
   */
  LINUX = 5,

  /**
   * @generated from enum value: OPERATING_SYSTEM_CHROMEOS = 6;
   */
  CHROMEOS = 6,

  /**
   * @generated from enum value: OPERATING_SYSTEM_UNKNOWN = 7;
   */
  UNKNOWN = 7
}

/**
 * Describes the enum analytics.v2.OperatingSystem.
 */
export const OperatingSystemSchema: GenEnum<OperatingSystem> =
  /*@__PURE__*/
  enumDesc(file_analytics_v2_analytics, 4)

/**
 * @generated from enum analytics.v2.RawEventsCol
 */
export enum RawEventsCol {
  /**
   * @generated from enum value: COL_UNSPECIFIED = 0;
   */
  COL_UNSPECIFIED = 0,

  /**
   * @generated from enum value: COL_ID = 1;
   */
  COL_ID = 1,

  /**
   * @generated from enum value: COL_EVENT_TIME = 2;
   */
  COL_EVENT_TIME = 2,

  /**
   * @generated from enum value: COL_ASSET_ID = 3;
   */
  COL_ASSET_ID = 3,

  /**
   * @generated from enum value: COL_ASSET_NAME = 4;
   */
  COL_ASSET_NAME = 4,

  /**
   * @generated from enum value: COL_DIRECTORY_NAME = 5;
   */
  COL_DIRECTORY_NAME = 5,

  /**
   * @generated from enum value: COL_OPERATING_SYSTEM = 6;
   */
  COL_OPERATING_SYSTEM = 6,

  /**
   * @generated from enum value: COL_DEVICE = 7;
   */
  COL_DEVICE = 7,

  /**
   * @generated from enum value: COL_EVENT_TYPE = 8;
   */
  COL_EVENT_TYPE = 8,

  /**
   * @generated from enum value: COL_DESTINATION = 9;
   */
  COL_DESTINATION = 9,

  /**
   * @generated from enum value: COL_LINK_NAME = 10;
   */
  COL_LINK_NAME = 10,

  /**
   * @generated from enum value: COL_COUNTRY = 11;
   */
  COL_COUNTRY = 11,

  /**
   * @generated from enum value: COL_STATE = 12;
   */
  COL_STATE = 12,

  /**
   * @generated from enum value: COL_CITY = 13;
   */
  COL_CITY = 13,

  /**
   * @generated from enum value: COL_ZIP = 14;
   */
  COL_ZIP = 14,

  /**
   * @generated from enum value: COL_LATITUDE = 15;
   */
  COL_LATITUDE = 15,

  /**
   * @generated from enum value: COL_LONGITUDE = 16;
   */
  COL_LONGITUDE = 16,

  /**
   * @generated from enum value: COL_GEO_TYPE = 17;
   */
  COL_GEO_TYPE = 17,

  /**
   * @generated from enum value: COL_APP_ID = 18;
   */
  COL_APP_ID = 18
}

/**
 * Describes the enum analytics.v2.RawEventsCol.
 */
export const RawEventsColSchema: GenEnum<RawEventsCol> =
  /*@__PURE__*/
  enumDesc(file_analytics_v2_analytics, 5)

/**
 * @generated from enum analytics.v2.GeoAdministrationLevel
 */
export enum GeoAdministrationLevel {
  /**
   * @generated from enum value: GEO_ADMINISTRATION_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GEO_ADMINISTRATION_LEVEL_COUNTRY = 1;
   */
  COUNTRY = 1,

  /**
   * @generated from enum value: GEO_ADMINISTRATION_LEVEL_REGION = 2;
   */
  REGION = 2,

  /**
   * @generated from enum value: GEO_ADMINISTRATION_LEVEL_STATE = 3;
   */
  STATE = 3,

  /**
   * @generated from enum value: GEO_ADMINISTRATION_LEVEL_COUNTY = 4;
   */
  COUNTY = 4,

  /**
   * @generated from enum value: GEO_ADMINISTRATION_LEVEL_POSTAL_CODE = 5;
   */
  POSTAL_CODE = 5
}

/**
 * Describes the enum analytics.v2.GeoAdministrationLevel.
 */
export const GeoAdministrationLevelSchema: GenEnum<GeoAdministrationLevel> =
  /*@__PURE__*/
  enumDesc(file_analytics_v2_analytics, 6)
